import dotenv from 'dotenv';
dotenv.config();

const SERVER_URL = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_PATH;

export { SERVER_URL};
